import React from 'react';
import classnames from 'classnames';
import {FormattedMessage} from 'react-intl';
import ReactSVG from 'react-svg';

const SummaryPageSkeleton = () => {
  const pageCssBEM = 'summaryPage';
  const classes = classnames(pageCssBEM, {
    [`${pageCssBEM}--skeleton`]: true
  });

  return (
    <div className={classes}>
      <div className={ `${ pageCssBEM }__container` }>
        <div className={ `${ pageCssBEM }__header` }>
          <FormattedMessage id='summary.recommendations.title' tagName='h2'/>
          <FormattedMessage id='summary.recommendations.subtitle' tagName='p'/>
        </div>
        <div className='loading-icon'>
          <ReactSVG src="/classpath/assets/images/loading.svg" />
        </div>
        <div className='mock-product product'>
          <span/>
          <span/>
          <span/>
        </div>
      </div>
    </div>
  );
};

export default SummaryPageSkeleton;

